import { get } from 'lodash';
import React from 'react';
import Accordion from 'shared/Accordion';
import NumberInputWidget from './NumberInputWidget';

export default (props) => {
  const { option } = props;
  const optionClassName = {
    className: 'bg-white rounded'
  };

  const onChange = (index, newValue) => {
    props.onChange({
      val: newValue.val + 'px',
      optional: {
        id: option.options[index]
      }
    });
  };

  const extractOption = (index) => {
    const attr = get(props.aggregatedOptions, `${props.option.options[index]}`);

    if (attr) {
      return parseInt(attr, 10);
    } else if (props.option?.default) return parseInt(props.option.default[index], 10);

    return option?.default ?? 0;
  };

  const extractValues = () => {
    const { option } = props;
    return option.options.map((_, index) => extractOption(index) ?? 0).join(', ');
  };

  return (
    <Accordion
      useInternalSelect={true}
      defaultSelection={false}
      headerText={props.label}
      smallHeaderText={true}
      selectedChildren={extractValues()}
      accordionClasses="bg-white"
      childrenClasses="flex-wrap"
    >
      <div className="flex w-full">
        <NumberInputWidget
          label={<i className="fa fa-arrow-up" />}
          value={extractOption(0) ?? 0}
          onChange={(newValue) => onChange(0, newValue)}
          className={'bg-ev-grey h-10'}
          option={optionClassName}
        />
        <NumberInputWidget
          label={<i className="fa fa-arrow-right" />}
          value={extractOption(1) ?? 0}
          onChange={(newValue) => onChange(1, newValue)}
          className={'bg-ev-grey h-10'}
          option={optionClassName}
        />
      </div>
      <div className="flex w-full">
        <NumberInputWidget
          label={<i className="fa fa-arrow-down" />}
          value={extractOption(2) ?? 0}
          onChange={(newValue) => onChange(2, newValue)}
          className={'bg-ev-grey h-10'}
          option={optionClassName}
        />
        <NumberInputWidget
          label={<i className="fa fa-arrow-left" />}
          value={extractOption(3) ?? 0}
          onChange={(newValue) => onChange(3, newValue)}
          className={'bg-ev-grey h-10'}
          option={optionClassName}
        />
      </div>
    </Accordion>
  );
};
